import styled from 'styled-components'

import { BaseText } from '../BaseText'

export const TextStyled = styled(BaseText)`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.body1)};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
`
